import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useGlobalContext from "../context/useGlobalContext";

const usePiPRedirect = () => {
  const navigate = useNavigate();
  const { pipState, setPipState } = useGlobalContext();

  const {
    triggered,
    meetingId,
    videoElement,
    tempVideoFileId,
    isTeamMeeting,
  } = pipState;

  useEffect(() => {
    const handleLeavePiP = () => {
      if (triggered && meetingId) {
        setPipState(prev => ({
          ...prev,
          triggered: false,
          resumeTabIndex: 2, // Go to Collaterals tab
          videoFileId: tempVideoFileId || null,
          resumeTime: videoElement?.currentTime ?? null,
        }));

        if (videoElement) {
          try {
            videoElement.pause();
            videoElement.src = "";
            videoElement.load();
          } catch (err) {
            console.error("Error cleaning up video before redirect", err);
          }
        }

        navigate(`/meeting/${meetingId}`, {
          state: {
            is_team_meeting_id: isTeamMeeting,
          },
        });
      }
    };

    if (videoElement) {
      videoElement.addEventListener("leavepictureinpicture", handleLeavePiP);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("leavepictureinpicture", handleLeavePiP);
      }
    };
  }, [triggered, meetingId, videoElement, tempVideoFileId, setPipState, navigate]);
};

export default usePiPRedirect;
